export default __webpack_public_path__ + "static/male-41f5abbb94bc2b1ae7af233c31b471de.png";